import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

import { isDemoEnvironment } from '../../../constants/global';
import { handleGql403 } from '../../../utils';
import { MutationDeleteDraftLineItemArgs } from '../types';
import { DELETE_DRAFT_LINE_ITEM } from './deleteDraftLineItem';

type DeleteDraftLineItem = {
  handleDeleteDraftLineItem: (lineItemId: string) => Promise<void>;
  loading: boolean;
};

const useDeleteDraftLineItem = (): DeleteDraftLineItem => {
  const [deleteDraftLineItem, { loading }] = useMutation<MutationDeleteDraftLineItemArgs>(DELETE_DRAFT_LINE_ITEM);

  const handleDeleteDraftLineItem = useCallback(
    async (lineItemId: string): Promise<void> => {
      if (isDemoEnvironment) {
        return Promise.resolve();
      }

      await deleteDraftLineItem({ variables: { lineItemId: lineItemId }, onError: handleGql403 });
    },
    [deleteDraftLineItem]
  );

  return {
    handleDeleteDraftLineItem,
    loading,
  };
};

export default useDeleteDraftLineItem;
